import React from 'react';
import { Box, Typography } from '@mui/material';
import { useParams, useNavigate, useOutletContext } from 'react-router-dom';

import BreadcrumbTrail from '../../../../layouts/BreadcrumbTrail';
import CenteredLoader from '../../../../components/loaders/PageLoader';

import EVNVersionTable from '../../components/EVNVersion/EVNVersionTable';
import { useEVNVersions } from '../../hooks/useEVNVersions';
import styles from './EVNVersion.styles';

import { useCrumb, useNavWithTrail } from '../../../../layouts/TrailProvider';

export default function EVNVersion() {
  const { isSidebarExpanded } = useOutletContext();
  const { evn } = useParams();
  const navigate = useNavigate();
  const nav = useNavWithTrail(navigate);

  const historyHref = `/home/evns/${encodeURIComponent(evn)}/history`;
  useCrumb('History', historyHref);

  const { versions, loading, evnData } = useEVNVersions(evn);

  const unitFromPage = evnData?.TrainNumber ?? null;
  const evnFromPage = evnData?.EVN ?? evn ?? null;

  const handleOpenMeter = (rowOrMeter, ctx = {}) => {
    let meterNumber = null;
    if (rowOrMeter == null) return;
    if (typeof rowOrMeter === 'string' || typeof rowOrMeter === 'number') {
      meterNumber = String(rowOrMeter);
    } else if (typeof rowOrMeter === 'object') {
      meterNumber =
        (rowOrMeter.MeterNumber || rowOrMeter.meterNumber || rowOrMeter.Meter || rowOrMeter.id) ??
        null;
      if (meterNumber != null) meterNumber = String(meterNumber);
    }

    if (!meterNumber) return;

    const unitToPass =
      (ctx && (ctx.unit ?? ctx.train ?? ctx.TrainNumber ?? ctx.Unit)) ??
      unitFromPage ??
      null;
    const evnToPass =
      (ctx && (ctx.evn ?? ctx.EVN ?? ctx.evnNumber)) ??
      evnFromPage ??
      null;

    nav(`/home/meters/${encodeURIComponent(meterNumber)}`, {
      state: {
        unit: unitToPass,
        evn: evnToPass,
      },
    });
  };

  return (
    <Box
      sx={{
        ...styles.versionDetails,
        marginLeft: isSidebarExpanded ? '240px' : '95px',
        width: isSidebarExpanded ? 'calc(100vw - 240px)' : 'calc(100vw - 95px)',
        transition: 'all 0.3s ease',
      }}
    >
      {loading ? (
        <CenteredLoader />
      ) : (
        <>
          <BreadcrumbTrail />

          <Box sx={styles.headerRow}>
            <Typography sx={styles.pageTitle}>EVN Meter History - {evn}</Typography>
          </Box>

          <EVNVersionTable
            rows={versions}
            unit={unitFromPage}
            evn={evnFromPage}
            onOpenMeter={handleOpenMeter}
          />
        </>
      )}
    </Box>
  );
}